import styled from "styled-components";

import { PrimaryText } from "@/components/Typography/Styled";

export const StyledFinGroup = styled(PrimaryText)`
    width: 100%;
    padding-top: 12px;
    font-size: 12px;
    font-weight: 400;
    line-height: 130%;
    letter-spacing: 0%;
    text-align: center;
    border-top: 1px solid ${({ theme }) => theme.secondaryBorderColor};
`;
